import React, { useState, useEffect } from 'react';
import Config from '../server.json';  


const PdfViewer = ({ fileUrl, pdfType, setPdfType, selectedOffice  }) => {
   const [pageNumber, setPageNumber] = useState(1);
  const [counts, setCounts] = useState({ externalCount: 0, internalCount: 0 });

   const folderPaths = {
    External: [`/${selectedOffice}-External/${selectedOffice}-External`],
    Internal: [`/${selectedOffice}-Internal/${selectedOffice}-Internal`],
  };

  
  useEffect(() => {
     fetch(`${Config.COUNT_IMAGE_API_URL}?officeId=${selectedOffice}`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((data) => setCounts({ 
        externalCount: data.externalCount, 
        internalCount: data.internalCount 
      }))
      .catch((err) => console.error('Failed to load image counts:', err));
  }, [selectedOffice]); 
  useEffect(() => {
     setPageNumber(1);
  }, [pdfType]);

  useEffect(() => {
    if (counts.externalCount === 0 && counts.internalCount === 0) {
      // No pages in both
      console.log('No pages available for both External and Internal.');
      return;
    }
  
    if (pdfType === 'External' && counts.externalCount === 0) {
      setPdfType('Internal');
    }
  
    if (pdfType === 'Internal' && counts.internalCount === 0) {
      setPdfType('External');
    }
  }, [counts, pdfType, setPdfType]);
  
  
  const totalPages = pdfType === 'External' ? counts.externalCount : counts.internalCount;

  const goToPrevPage = () => setPageNumber((prev) => (prev <= 1 ? 1 : prev - 1));
  const goToNextPage = () => setPageNumber((prev) => (prev >= totalPages ? totalPages : prev + 1));

  const getImagePath = () => {
    const paddedPage = String(pageNumber).padStart(3, '0');
    const paths = folderPaths[pdfType];
  
     for (const basePath of paths) {
      const encodedPath = basePath.replace(/ /g, '%20');
      const imagePath = `${encodedPath}-page-${paddedPage}.jpg`;
  
  
      return imagePath;  
    }
  
    return '';  
  };
  
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setPageNumber((prev) => (prev >= totalPages ? totalPages : prev + 1));
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setPageNumber((prev) => (prev <= 1 ? 1 : prev - 1));
        }
      }
    };
  
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [totalPages]);

  
  return (
    <div style={{ width: '100%', maxWidth: '800px', margin: 'auto' }}>
      <div style={{ marginBottom: 15 }}>
      
      </div>

      {totalPages === 0 ? (
        <div>Loading pages...</div>
      ) : (
        <>
          <img
            src={getImagePath()}
            alt={`Page ${pageNumber}`}
            style={{ width: '100%', height: '90vh', border: '1px solid #ccc' }}
            onError={() => alert(`Image not found: ${getImagePath()}`)}
          />

          <div
            style={{
              marginTop: 5,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span>
              Page {pageNumber} of {totalPages}
            </span>

            <div>
              <button
              onMouseDown={goToNextPage}
              onMouseUp={goToPrevPage}
                onClick={goToPrevPage}
                disabled={pageNumber <= 1}
                style={{
                  marginRight: 10,
                  padding: '8px 16px',
                  backgroundColor: pageNumber <= 1 ? '#ccc' : '#007BFF',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.3s',
                }}
              >
                Previous
              </button>

              <button
              onMouseDown={goToNextPage}
              onMouseUp={goToPrevPage}
                onClick={goToNextPage}
                disabled={pageNumber >= totalPages}
                style={{
                  padding: '8px 16px',
                  backgroundColor: pageNumber >= totalPages ? '#ccc' : '#28A745',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: pageNumber >= totalPages ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.3s',
                }}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PdfViewer;
